import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { MutableRefObject, useEffect, useRef, useState } from 'react';
import style from './search-block.module.scss'
import searchIcon from '/public/assets/icons/icn-search.svg'
import clearInput from '/public/assets/icons/clear-input.svg'
import { KeyAction } from '@models/blog-search.types';

const SearchBlock = ({onSearch}: any) => {
    let router = useRouter();
    let inputRef = useRef() as MutableRefObject<HTMLInputElement>;
    let [active, setActive] = useState(false);
    let [searchText, setSearchText] = useState("");

    function searchTextChange(text: string) {
        setSearchText(text);
        if (typeof onSearch === 'function') {
            onSearch(text);
        }
    }

   function clearInputValue(){
    if (inputRef) {
        inputRef.current.value = '';
        setSearchText('')
        onSearch('');
    }
   }

   function handleKeyDown(event: React.KeyboardEvent) {
    if (event.key === KeyAction.Enter) {
        inputRef.current.blur();
    }
}

    useEffect(() => {
        let searchBlock = document.getElementById('searchBlock');
        if (active) {
            searchBlock?.classList.add(style.input_active);
        } else {
            searchBlock?.classList.remove(style.input_active);
        }
    }, [active])

    return (
        <>
            <div id="searchBlock" className={style.search__block}>
                <div className={style.search__icon}>
                    <Link scroll={false} href={router.asPath} shallow={true}>
                        <a>
                            <Image layout={'fill'} src={searchIcon}  alt='search-icon'/>
                        </a>
                    </Link>
                </div>
                <div id="searchStroke" className={style.search__stroke}>
                    <div className={style.search__input}>
                        <input ref={inputRef} value={searchText} onKeyDown={handleKeyDown} onChange={()=> searchTextChange(inputRef.current.value)} id="searchInput" onBlur={() => setActive(false)} onFocus={() => setActive(true)} type="text" placeholder="Search" />
                    </div>
                    {searchText && (
                    <div  onClick={clearInputValue} className={style.search__clear}>
                        <Image layout={'fill'} src={clearInput}  alt='search-icon'/>
                    </div>
                )}
                </div>
            </div>
        </>
    )
}

export default SearchBlock;
